module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("PREFACE:")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("ENCORE! ENCORE!")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This is a sequel to "), _c('i', [_vm._v("The Destiny of the Sword")]), _vm._v(". It can be read on its own, but if you haven’t read the original trilogy, I urge you to start with "), _c('i', [_vm._v("The Reluctant Swordsman")]), _vm._v(" and leave this book for last, because otherwise it will spoil the rest for you. If you have read the first three, then welcome back to the World of the Goddess.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This is a book I said I would never write. After every series (eleven so far) fans have asked me for sequels. I always decline, because much of my enjoyment of fantasy comes from exploring an impossible world. Once I have done that, I want to move on and explore another. “The Seventh Sword” was not only the first of my series, it has also been the most successful. Re-issued as e-books, it has again outsold all my other works. Naturally, I have been asked many times for encores.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I refused because I thought that the demigod had sewed everything up at the end of the third book, in an epilogue called, “The Last Miracle”. He did hint at later problems, but I couldn’t see a story in them. Then one day lightning struck and I saw that, no matter what happened, if a god said it wasn’t a miracle, then it wasn’t a miracle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This Volume Four cannot have exactly the same flavor as the original three, for much of that came from the conflict between Wallie and the World. By now he must have adjusted to its strangeness, but we all encounter new problems as we age, and Wallie is no exception.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("(A final note. When names begin with double consonants, both letters should be pronounced. Thus Nnanji sounds like "), _c('i', [_vm._v("N’Nanji ")]), _vm._v("and Jja roughly like "), _c('i', [_vm._v("Zsa-Zsa")]), _vm._v(".)")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c3c2776","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 75
// module chunks = 0